export enum BrokerStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING_EMAIL = 'pending_email',
  DRAFT = 'draft'
}
